import React from 'react';

const About = () => {
  // Direct link to your logo
  const logoUrl = "https://i.ibb.co/LXq09s62/logo.png";

  return (
    <section id="about" className="py-24 md:py-32 px-6 bg-zinc-950 relative">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          
          {/* Logo / Image Side */}
          <div className="order-2 md:order-1 relative">
            <div className="relative aspect-[4/5] border border-zinc-800 bg-zinc-900 overflow-hidden group">
              {/* Background Gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-zinc-800 to-black opacity-50"></div>
              
              {/* Animated Border Frame */}
              <div className="absolute top-10 left-10 right-10 bottom-10 border border-zinc-700/50 transform group-hover:scale-95 transition-transform duration-700 z-10"></div>
              
              {/* Logo replacing the "M" placeholder */}
              <div className="absolute inset-0 flex items-center justify-center p-20">
                <img 
                  src={logoUrl} 
                  alt="Manifest Logo" 
                  className="w-full h-full object-contain opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700"
                />
              </div>
            </div>
          </div>
          
          {/* Text Content Side */}
          <div className="order-1 md:order-2">
            <h2 className="text-3xl md:text-4xl font-light text-white mb-8 tracking-wide">
              WE ARE THE ARCHITECTS <br/> OF <span className="text-zinc-500 italic">MOMENTS</span>
            </h2>
            <div className="space-y-6 text-zinc-400 font-light leading-relaxed">
              <p>
                At MANIFEST Entertainment, we don't just manage events; we curate experiences that linger in memory long after the lights go down. Based at the intersection of culture and luxury, we specialize in bringing the unattainable within reach.
              </p>
              <p>
                Our expertise spans across managing top-tier talent, orchestrating private gatherings for the elite, and producing large-scale club sensations. We are the silent engine behind the noise, the precision behind the chaos.
              </p>
              <div className="pt-8">
                {/* You can add a "Read More" or Signature here later */}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;